import { render, staticRenderFns } from "./Completado.vue?vue&type=template&id=55c8c514"
import script from "./Completado.vue?vue&type=script&lang=js"
export * from "./Completado.vue?vue&type=script&lang=js"
import style0 from "./Completado.vue?vue&type=style&index=0&id=55c8c514&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports